import { isObject } from 'typechecker'
import Store from '@/classes/Store'
import PricedCar from '@/classes/PricedCar'
import ggoApi from '@/modules/ggo-api'

export default function () {
  const fetchStore = async (id: number) => {
    const { success, data, error } = await ggoApi.getStore({ id })

    if (success && data) {
      if (!isObject(data)) throw new TypeError('`store response` must be an object!')

      return new Store({
        ...data.store,
        taxID: data.store.taxId,
        rating: {
          score: data.rating.score_all_float,
          count: data.rating.count,
        },
        score: {
          all: data.rating.score_all,
          service: data.rating.score_service,
          manner: data.rating.score_manner,
          clean: data.rating.score_clean,
        },
      })
    } else if (error === 'Network Error') throw new Error('網路斷線，連線後點擊重試')
    else throw new Error('系統錯誤，點擊重試')
  }

  const fetchStoreCars = async (id: number, params?: any) => {
    const { success, data, error } = await ggoApi.getStoreCars({ id, params })

    if (success && data) {
      if (!isObject(data)) throw new TypeError('`store response` must be an object!')

      return data.cars.map(car => new PricedCar(car))
    } else if (error === 'Network Error') throw new Error('網路斷線，連線後點擊重試')
    else throw new Error('系統錯誤，點擊重試')
  }

  return {
    fetchStore,
    fetchStoreCars,
  }
}
